import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep6 = (state) => state.get('step6');

const makeSelectStep6 = () =>
  createSelector(selectStep6, (step6State) => ({
    claimForCancellationAmendmentOrDelay: mapWithDefault(step6State, () => step6State.getIn(['form', 'claimForCancellationAmendmentOrDelay']), ''),
    claimForTripCancellationExpenses: mapWithDefault(step6State, () => step6State.getIn(['form', 'claimForTripCancellationExpenses']), ''),
    claimForTripDisruptionOrAdditionalExpenses: mapWithDefault(step6State, () => step6State.getIn(['form', 'claimForTripDisruptionOrAdditionalExpenses']), ''),
    claimForTripResumptionExpenses: mapWithDefault(step6State, () => step6State.getIn(['form', 'claimForTripResumptionExpenses']), ''),
    claimForAlternativeTransportExpenses: mapWithDefault(step6State, () => step6State.getIn(['form', 'claimForAlternativeTransportExpenses']), ''),
    claimForATravelDelay: mapWithDefault(step6State, () => step6State.getIn(['form', 'claimForATravelDelay']), ''),
    dateCancellationOrAmendmentMade: mapWithDefault(step6State, () => step6State.getIn(['form', 'dateCancellationOrAmendmentMade']), ''),
    reasonForCancellationOrAmendment: mapWithDefault(step6State, () => step6State.getIn(['form', 'reasonForCancellationOrAmendment']).toJS(), ''),
    cancellationExpenses: mapWithDefault(step6State, () => step6State.getIn(['form', 'cancellationExpenses']).toJS(), ''),
    additionalExpenses: mapWithDefault(step6State, () => step6State.getIn(['form', 'additionalExpenses']).toJS(), ''),
    delayedTravelReason: mapWithDefault(step6State, () => step6State.getIn(['form', 'delayedTravelReason']), ''),
    departDate: mapWithDefault(step6State, () => step6State.getIn(['form', 'departDate']), ''),
    departTime: mapWithDefault(step6State, () => step6State.getIn(['form', 'departTime']), ''),
    departedDate: mapWithDefault(step6State, () => step6State.getIn(['form', 'departedDate']), ''),
    departedTime: mapWithDefault(step6State, () => step6State.getIn(['form', 'departedTime']), ''),
    receivedCompensation: mapWithDefault(step6State, () => step6State.getIn(['form', 'receivedCompensation']), ''),
    delayedTravelExpenses: mapWithDefault(step6State, () => step6State.getIn(['form', 'delayedTravelExpenses']).toJS(), ''),
    amountOfCompensation: mapWithDefault(step6State, () => step6State.getIn(['form', 'amountOfCompensation']), ''),
    amountOfCompensationCurrency: mapWithDefault(step6State, () => step6State.getIn(['form', 'amountOfCompensationCurrency']), ''),
    dateCompensationWasReceived: mapWithDefault(step6State, () => step6State.getIn(['form', 'dateCompensationWasReceived']), ''),
    compensationDescription: mapWithDefault(step6State, () => step6State.getIn(['form', 'compensationDescription']), ''),
    areThereAnyAdditionalExpensesToBeClaimed: mapWithDefault(step6State, () => step6State.getIn(['form', 'areThereAnyAdditionalExpensesToBeClaimed']), ''),
    enableTime: mapWithDefault(step6State, () => step6State.getIn(['form', 'enableTime']), null),

  }));

const makeSelectStep6Errors = () =>
  createSelector(selectStep6, (step6State) => step6State.get('errors'));

export {
  makeSelectStep6,
  makeSelectStep6Errors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step6/selectors.js